import * as Sentry from "@sentry/browser"

Sentry.init({
  dsn: "https://1cd98d5d75a748df8884c29c59c53981@pinkbeton.bugsink.com/1", // use EU DSN if possible
  release: `foodrestos@${process.env.version}`,
  enabled: process.env.NEXT_PUBLIC__APP_ENV === "production",
  integrations: [],
  tracesSampleRate: 0,
})
